(function() {
    'use strict';

    var errorMsgFactory = function($timeout) {

        var connectionError = function(result){
        	var error = '<strong>Connection or other problem. </strong> Error '+ result.status + ': ' + result.statusText + '.<br />';
            if(result.status == 401){
                error += '<small>Your session may have expired - please try to login again.</small>';
            }
            // TODO: more statuses
            return error;
        }

        var connectionErrorDropdown = function(result) {
            // ng-click="$event.stopPropagation();" would be great, but the we'd have to compile whole thing...
            return '<li><a href="javascript:void(0);" class="text-danger">'+connectionError(result)+'</a></li>';
        }


        // We now return a public API for our service.
        return {
        	connectionError         : connectionError,
            connectionErrorDropdown : connectionErrorDropdown
        };
    }
    errorMsgFactory.$inject = ['$timeout'];
    angular.module('app').factory('errorMsgFactory', errorMsgFactory);

}());


